/**
 * Pequeñas Puntadas — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (hero, offer, closing and mobile sticky bar).
 */
export const CHECKOUT_URL = 'https://pequenas-puntadas.impultienda.ar/checkout'

export const PRICE = {
  value: 19900,
  currency: 'ARS',
  label: '$19.900',
  compareAtLabel: '$49.990',
  /** $49.990 → $19.900 = 60,19 % → shown rounded. Savings: $30.090. */
  discountLabel: '60% OFF',
  savingsLabel: 'Ahorrás $30.090',
  /** $19.900 / 310 moldes = $64,19. */
  perModelLead: '310 moldes por $19.900',
  perModelHighlight: 'Menos de $65 por molde (310 moldes)',
  /** 2 × $9.950 = $19.900, no financing surcharge. */
  installmentsLabel: '2 cuotas sin interés de $9.950',
  perModelNote: 'Promedio dentro de la colección completa.',
  note: 'Pago único',
  delivery: 'Después del pago, accedés al enlace de descarga de todos los archivos.',
} as const

export const LAUNCH_LABEL = 'Descuento de lanzamiento'

/** Purchase CTA label — shared by every checkout button so they always match. */
export const BUY_LABEL = `Quiero los 310 moldes — ${PRICE.label}`
export const STICKY_BUY_LABEL = 'Quiero los moldes'
/** Single discreet line at the very end of the page; never under other buttons. */
export const GUARANTEE_NOTE =
  'Garantía de 7 días: si tenés algún problema con tu compra, escribinos a atencion.creativodigital@gmail.com.'
